import { Box } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import NarrativeEditableFields from "./EditableFields";

function NarrativeContainer({ open }: { open: boolean }) {
  return (
    <>
      <SectionCollapsible open={open} label="Narrative">
        <Box data-testid="narrative-section-collapsible">
          <NarrativeEditableFields />
        </Box>
      </SectionCollapsible>
    </>
  );
}

export default NarrativeContainer;
